import toast, { Toaster } from "react-hot-toast";
import "./App.css";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

function App() {
  const location = useLocation();

  const isAuthenticated =
    !!localStorage.getItem("authToken") || location.pathname === "/login" || location.pathname === "/live-collection" || location.pathname === "/sent";

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("token")) {
      localStorage.setItem("authToken", urlParams.get("token"));
    } else if (!token && window.location.pathname !== "/login" && window.location.pathname !== "/live-collection" && window.location.pathname !== "/sent") {
      navigate("/login");
      toast.error("Please login to continue!");
    }
  }, [navigate]);

  return (
    <QueryClientProvider client={queryClient}>
      <div>
        {isAuthenticated && <Outlet />}
        <Toaster
          position="top-center"
          reverseOrder={false}
          toastOptions={{
            style: {
              fontSize: "13px",
            },
          }}
        />
      </div>
    </QueryClientProvider>
  );
}

export default App;
